import utils from "../utils";

function init() {

	var accordionTexts = document.querySelectorAll('.flex-accordion .accordion .text');

	if(accordionTexts.length > 0){
		utils.forEach(accordionTexts, function (index, accordionText) {
			var realHeight = accordionText.scrollHeight;
			accordionText.style.maxHeight = realHeight + 'px';
		});
	}

	var accordionTogglers = document.querySelectorAll('.block-accordions .block-accordion .accordion-head'),
		accordions = document.querySelectorAll('.block-accordions .block-accordion');

	if(accordionTogglers.length > 0){
		utils.forEach(accordionTogglers, function (index, accordionToggler) {
			accordionToggler.addEventListener("click", () => {
				utils.forEach(accordions, function (index, accordion) {
					accordion.classList.remove('open');
				})
				accordionToggler.parentElement.classList.toggle('open');
			});
		});
	}

}

window.accordionToggler = function (button){

	var accordion = button.parentElement,
		openLabel = button.getAttribute('data-label-open'),
		closeLabel = button.getAttribute('data-label-close');

	if(accordion.classList.contains('close')){
		accordion.classList.remove("close");
		button.setAttribute('aria-label',closeLabel);
	} else {
		accordion.classList.add("close");
		button.setAttribute('aria-label',openLabel);
	}


}

export default { init };
